import Typography from '@mui/material/Typography'
import {HealthConditionSubTitle} from '../HealthCondition/HealthConditionStyle'
import {TemporaryToggle} from '../../UserManagement/UserManagementStyle'
import PropTypes from 'prop-types'
import {Box, Grid} from '@mui/material'
import {useCustomDashboardViewProvider} from '../../../store/hooks/customDashboardView'
import {ChatbotGrid, ToggleStack} from './ChatbotCopyStyle'

// this file has the code for the chatbot component in admin panel to enable or disable the chatbot
const ChatbotComponent = ({selectedChat, setSelectedChatbot}) => {
  const setSelectedToggleFunction = () => {
    setSelectedChatbot([1 - selectedChat[0]])
  }
  const {prismProgram} = useCustomDashboardViewProvider()

  return (
    <Box tabIndex={0} aria-label='Agent'>
      <ChatbotGrid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HealthConditionSubTitle>
            This will allow users to interact with the {prismProgram} Agent, ask it questions, and export their
            findings.
          </HealthConditionSubTitle>
        </Grid>
        <Grid item xs={12} md={6}>
          <ToggleStack>
            <Typography>Off</Typography>
            <TemporaryToggle
              data-testid='assistant-toggle'
              checked={selectedChat?.length > 0 ? selectedChat[0] : false}
              onChange={setSelectedToggleFunction}
              aria-label='Agent Toggle Button'
            />
            <Typography>On</Typography>
          </ToggleStack>
        </Grid>
      </ChatbotGrid>
    </Box>
  )
}

ChatbotComponent.propTypes = {
  setSelectedChatbot: PropTypes.func,
  selectedChat: PropTypes.array
}

export default ChatbotComponent
